import CommentItem from "../../components/Comments/CommentItem.jsx";
import {useEffect, useState} from "react";
import { comments } from "../../lib/api";
import * as  imageConversion from "image-conversion"
import {toast} from "react-toastify";
import {useLocation} from "@tanstack/react-router";
import { useAuth } from "../../lib/auth";
import { sessionStorageGet } from "../../lib/window-shim";

function nl2br(input) {
    return (input.replace(/\n/g, <br/>))
}

let uploadFiles = []

/**
 * Activity component.
 *
 * Displays comment/activity feed on a profile.
 * Features:
 * - Comment input with image paste support and compression
 * - Upload files as attachments
 * - List of comments (CommentItem components)
 * - Shows user avatar next to input
 * - Backend sync for comments
 *
 * Uses image-conversion for compressing pasted images.
 * Shows toast notification for image compression stats.
 * Comments are displayed in reverse chronological order.
 *
 * @param {Object} props - Component props
 * @param {number} props.start - Pagination start (unused)
 * @param {number} props.end - Pagination end (unused)
 * @param {string} props.itemHash - Hash identifying the item/profile for comments
 * @param {string|number} props.userID - User whose comments to fetch
 * @param {Object} props.profileInfo - Profile data for context
 * @param {string} props.metaAction - Action description for comment meta
 * @param {boolean} props.showActions - Whether to show action buttons on comments
 * @param {string|number} props.recipientId - Recipient of comments
 * @param {string} props.actionLocation - Location/URL for comment context
 * @returns {React.ReactElement} Activity section with comment form
 */
const Activity = ({start, end, itemHash, userID, profileInfo, metaAction, showActions, recipientId, actionLocation}) => {

    const [comms, sComms] = useState([])
    const [commsCnt, scTotal] = useState(null)
    const [collapse, sCollapse] = useState(true);
    const [sub, enSub] = useState(false);
    const [fileAdded, addF] = useState(0)

    let loc = useLocation().pathname;

    const { user: token } = useAuth();
    const rawToken = sessionStorageGet('token');

    function imgErr(e) {
        const fb = "https://cdn.stealthisnft.xyz/u/0/profile/avatar.jpg";
        if (e.target.src === fb) return; // prevent loop
        e.target.onError = null;
        if (e.target.id.includes('avatar')) {
            e.target.src = fb;
        }
    }

    const submitComment = async () => {

        let commentElem = document.getElementById("comment");
        let comment = commentElem.value;
        commentElem.value = ""


        let jData =  {
            start: start, end: end, hash: itemHash, comment: comment,  forUser: null, meta: {}
        }

        if(metaAction) jData.meta.action = metaAction
        if(actionLocation) jData.meta.actionLocation = actionLocation
        if(recipientId) jData.meta.recipientId = recipientId;

        if(uploadFiles.length){
            jData.fileObjects = uploadFiles;
        }

        await comments(jData)
            .then((response) => {
                sComms(response.comms)
                scTotal(response.cc)
                uploadFiles = [];
                addF(Math.random())
            })

    }

    function toggleCollapse() {


    }

    useEffect(() => {
        let jData = {start: start, end: end, hash: itemHash, getAll: userID, forUser: null}
        comments(jData)
            .then(response => {
                sComms(response.comms)
                scTotal(response.cc)
            })
    }, [itemHash])

    useEffect(() => {

        return () => {
            sComms([])
        }
    }, [])

    useEffect(()=>{
    }, [fileAdded])

    function processInput() {
        let inp = document.getElementById("comment")
        if (inp.value.length > 0) {
            enSub(true)
        } else {
            enSub(false)
        }
    }


    const genComments = (comms) => {

        let opt;
        //  console.log("COMMS", comms)
        //showActions = false;
        if (comms?.length) {
            opt = comms.slice(0).reverse().map((item) => <> {
                <CommentItem flags={"bob"}
                             userId={item.userId}
                             item={item}
                             action={item?.meta?.length && JSON.parse(item?.meta).action?.length ? JSON.parse(item?.meta).action : null }
                             showActions={showActions}

                />} </>)


        }
        return (opt)

    }

    //console.log(profileInfo)

    async function onPasteCaptureHandler(e) {
        e.preventDefault();
        let data;

        if (e.clipboardData.files.length) {
            const fileObject = e.clipboardData.files[0];
            const file = {
                getRawFile: () => fileObject,
                name: fileObject.name,
                size: fileObject.size,
                uid: "aaa-aaa-aaaa",
                status: 2,
                progress: 0,
            };
            let reader = new FileReader();

            reader.readAsDataURL(file.getRawFile())

            reader.onload = async function(e){

                let fileToProcess = await imageConversion.dataURLtoFile(reader.result);
                let divisor = 0.1;
                if (file.size === "image/jpeg") {
                    divisor = 0.25
                }
                if (file.size < 70000) {
                    divisor = 0.8
                }
                let nimg = reader.result;
                imageConversion.compressAccurately(fileToProcess, {
                    size: Math.floor((reader.result.length / 1000) * divisor),
                    type: "image/jpeg",
                }).then(async res => {

                    try {
                        nimg = await imageConversion.filetoDataURL(res)
                        toast(<>Compressed image to {(100* nimg.length) / reader.result.length}% of original size<br/> oi {reader.result.length} ni{nimg.length}</>)
                    } catch (e) {
                        toast("Problem converting image")
                    }

                })
                    .catch(e=>{
                        toast("Problem converting image: "+e?.message)
                    })

                uploadFiles.push({url: nimg, name: file.name, size: file.size})
                addF(Math.random())

            }


        }

        for (const [id, item] of Object.entries(e.clipboardData.items)) {
            try {
                data = e.clipboardData.getData(item.type);
            } catch (e) {
                // error
            }
        }

        //console.log("PCAP", e.clipboardData.items[0].type, e.clipboardData.items[1].type)

        //  e.clipboardData.items[0].getAsString((st)=> {
        //     console.log("PCAP", st, e.clipboardData.items)
        //})
    }

    return (
        <>
            {token?.auth ?
                <div className="pixel-card p-3 mb-2">
                    <div className="d-flex align-items-start gap-3">
                        <img
                            onError={(e)=>imgErr(e)} id={"avatar_"+token?.account?.id}
                            className="avatar avatar-sm"
                            src={"https://cdn.stealthisnft.xyz/u/" + token?.account?.id + "/profile/avatar.jpg"}
                            alt={"User avatar"}/>
                        <textarea
                            onPasteCapture={(e) => onPasteCaptureHandler(e)}
                            placeholder={"Post a comment on " + profileInfo?.username + "'s profile"} id="comment"
                            onKeyUp={() => processInput()}
                            className="flex-fill input-purple"
                            style={{minHeight: "100px", resize: "vertical"}}/>

                    </div>
                    {sub || uploadFiles?.length ?
                        <div className="d-flex flex-wrap gap-2 mt-3">
                            <div className="flex-fill">
                                { uploadFiles?.length  ?
                                    <div className="d-flex flex-wrap gap-1">
                                        {uploadFiles.map((i, idx) =>
                                            <img key={idx} style={{maxHeight:"32px",maxWidth:"32px", objectFit: "cover"}} src={i.url} alt={i.name}/>
                                        )}
                                    </div>
                                    : null }
                            </div>

                            <button
                                    onClick={() => {toast(<><span className="text-bolder">Woah there, slow down!</span><br/><br/>This feature is still in development, it should be available soon!</>)}}
                                    className="btn btn-success btn-sm">Send crypto
                                </button>
                            <button
                                    onClick={() => submitComment('withCrypto')}
                                    className="btn btn-info btn-sm">Post
                                </button>
                        </div>
                        : null}
                </div>
                :
                null}
            <div className="pixel-card">
                <div className="card-header pb-0 p-3 pt-2">
                    <span className="mb-0 text-bold text-light">Recent Activity</span>
                </div>
                <div className="card-body p-3">
                    {genComments(comms)}
                </div>
            </div>
        </>
    )


}

export default Activity;
